import { UserCertificationItem } from '@/components/custom';
import { IVerifications } from '@/lib/interface.ts';
import { cn } from '@/lib/utils';

type TProps = {
	verifications: IVerifications[];
}

const BodyPageCertifications = ({ verifications }: TProps) => (
	<div className={cn(
		'flex flex-col gap-4',
		'md:flex-row md:justify-center md:flex-wrap'
	)}>
		{
			verifications
				.map(
					item => (
						<UserCertificationItem
							readonly
							key={item._id}
							item={item as any}
							className={'self-center mx-0 w-full md:w-auto md:mb-auto'} />
					)
				)
		}
	</div>
);

export default BodyPageCertifications;
